// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2qjFG","bigColWidth":"Table_bigColWidth__2lTCX","biggerColWidth":"Table_biggerColWidth__yHhBR","row":"Table_row__3JSCi","col":"Table_col__g960L"};